import { parseDateValue } from '@/utils/formatDate'

export function sortCasosByFechaInicioDesc(casos) {
  return [...(casos ?? [])].sort((a, b) => {
    const dateA = parseDateValue(a?.fecha_inicio)
    const dateB = parseDateValue(b?.fecha_inicio)
    return (Number.isNaN(dateB) ? 0 : dateB) - (Number.isNaN(dateA) ? 0 : dateA)
  })
}
